import { IGetConsumersListModel, ISearchConsumersListModel, IUpdateConsumerModel } from '../../models/consumers';
import { getConsumersListApi, searchConsumersListApi, updateConsumerApi } from '../../services/bToC/consumers';
import { getErrorObject } from '../../utilities/utils';
import Constants from 'utilities/appConstants';
import { showMsgFromJson } from '../common';

export const types = {
	// Fetch list
	CONSUMERS_GET_LIST_REQUEST: 'consumer/CONSUMERS_GET_LIST_REQUEST',
	CONSUMERS_GET_LIST_FAILURE: 'consumer/CONSUMERS_GET_LIST_FAILURE',
	CONSUMERS_GET_PENDING_LIST_SUCCESS: 'consumer/CONSUMERS_GET_PENDING_LIST_SUCCESS',
	CONSUMERS_GET_APPROVAL_LIST_SUCCESS: 'consumer/CONSUMERS_GET_APPROVAL_LIST_SUCCESS',
	// Search list
	CONSUMERS_SEARCH_LIST_REQUEST: 'consumer/CONSUMERS_SEARCH_LIST_REQUEST',
	CONSUMERS_SEARCH_LIST_FAILURE: 'consumer/CONSUMERS_SEARCH_LIST_FAILURE',
	CONSUMERS_SEARCH_LIST_SUCCESS: 'consumer/CONSUMERS_SEARCH_LIST_SUCCESS',
	// Add New Consumer
	CONSUMERS_ADD_NEW_REQUEST: 'consumer/CONSUMERS_ADD_NEW_REQUEST',
	CONSUMERS_ADD_NEW_SUCCESS: 'consumer/CONSUMERS_ADD_NEW_SUCCESS',
	CONSUMERS_ADD_NEW_FAILURE: 'consumer/CONSUMERS_ADD_NEW_FAILURE',
	// Update Consumer
	CONSUMER_UPDATE_NEW_REQUEST: 'consumer/CONSUMER_UPDATE_NEW_REQUEST',
	CONSUMER_UPDATE_NEW_SUCCESS: 'consumer/CONSUMER_UPDATE_NEW_SUCCESS',
	CONSUMER_UPDATE_NEW_FAILURE: 'consumer/CONSUMER_UPDATE_NEW_FAILURE',
};

const initialState = {
	approvalFilter: {
		sorting: '',
	},
	approvalPage: 1,
	approvalCount: 0,
	approvalTotalCount: 0,
	approvalNoOfItemsReceived: 0,
	pendingPage: 1,
	pendingCount: 0,
	pendingTotalCount: 0,
	pendingNoOfItemsReceived: 0,
	isLoading: false,
	error: null,
	approvalList: [],
	pendingList: [],
};

export const consumers = (state = initialState, action) => {
	switch (action.type) {
		case types.CONSUMERS_GET_LIST_REQUEST:
		case types.CONSUMERS_GET_PENDING_LIST_SUCCESS:
		case types.CONSUMERS_GET_APPROVAL_LIST_SUCCESS:
		case types.CONSUMERS_GET_LIST_FAILURE:
			return getConsumersListReducer(state, action);
		case types.CONSUMERS_SEARCH_LIST_REQUEST:
		case types.CONSUMERS_SEARCH_LIST_FAILURE:
		case types.CONSUMERS_SEARCH_LIST_SUCCESS:
			return searchConsumersListReducer(state, action);
		case types.CONSUMER_UPDATE_NEW_REQUEST:
		case types.CONSUMER_UPDATE_NEW_SUCCESS:
		case types.CONSUMER_UPDATE_NEW_FAILURE:
			return updateConsumerReducer(state, action);
		default:
			return state;
	}
};

const getConsumersListReducer = (state, action) => {
	switch (action.type) {
		case types.CONSUMERS_GET_LIST_REQUEST:
			return { ...state, isLoading: true };
		case types.CONSUMERS_GET_PENDING_LIST_SUCCESS:
			if (Number(action.page) === 1) {
				return {
					...state,
					isLoading: false,
					pendingList: [...action.payload],
					error: null,
					pendingCount: Number(action.payload.length),
					pendingNoOfItemsReceived: Number(action.payload.length),
					pendingTotalCount: Number(action.totalCount),
					pendingPage: Number(action.page),
				};
			}
			return {
				...state,
				isLoading: false,
				pendingList: [...state.pendingList, ...action.payload],
				error: null,
				pendingCount: Number(state.pendingList.length + action.payload.length),
				pendingNoOfItemsReceived: Number(state.pendingList.length + action.payload.length),
				pendingTotalCount: Number(action.totalCount),
				pendingPage: Number(action.page),
			};
		case types.CONSUMERS_GET_APPROVAL_LIST_SUCCESS:
			if (Number(action.page) === 1) {
				return {
					...state,
					isLoading: false,
					approvalList: [...action.payload],
					error: null,
					approvalCount: Number(action.payload.length),
					approvalNoOfItemsReceived: Number(action.payload.length),
					approvalTotalCount: Number(action.totalCount),
					approvalPage: Number(action.page),
				};
			}
			return {
				...state,
				isLoading: false,
				approvalList: [...state.approvalList, ...action.payload],
				error: null,
				approvalCount: Number(state.approvalList.length + action.payload.length),
				approvalNoOfItemsReceived: Number(state.approvalList.length + action.payload.length),
				approvalTotalCount: Number(action.totalCount),
				approvalPage: Number(action.page),
			};
		case types.CONSUMERS_GET_LIST_FAILURE:
			return {
				...state,
				isLoading: false,
				pendingList: action.payload,
				error: null,
				pendingCount: action.payload.length,
			};
		default:
			return state;
	}
};

const searchConsumersListReducer = (state, action) => {
	switch (action.type) {
		case types.CONSUMERS_SEARCH_LIST_REQUEST:
			return { ...state, isLoading: true };
		case types.CONSUMERS_SEARCH_LIST_SUCCESS:
			if (Number(action.page) === 1) {
				return {
					...state,
					isLoading: false,
					approvalList: [...action.payload],
					error: null,
					approvalCount: Number(action.payload.length),
					approvalNoOfItemsReceived: Number(action.payload.length),
					approvalTotalCount: Number(action.totalCount),
					approvalPage: Number(action.page),
				};
			}
			return {
				...state,
				isLoading: false,
				approvalList: [...state.approvalList, ...action.payload],
				error: null,
				approvalCount: Number(state.approvalList.length + action.payload.length),
				approvalNoOfItemsReceived: Number(state.approvalList.length + action.payload.length),
				approvalTotalCount: Number(action.totalCount),
				approvalPage: Number(action.page),
			};
		case types.CONSUMERS_SEARCH_LIST_FAILURE:
			return {
				...state,
				approvalPage: 1,
				approvalCount: 0,
				approvalTotalCount: 0,
				approvalNoOfItemsReceived: 0,
				approvalList: [],
				isLoading: false,
			};
		default:
			return state;
	}
};

const updateConsumerReducer = (state, action) => {
	switch (action.type) {
		case types.CONSUMER_UPDATE_NEW_REQUEST:
			return { ...state, isLoading: true };
		case types.CONSUMER_UPDATE_NEW_SUCCESS:
			return {
				...state,
				isLoading: false,
				pendingList: [...action.payload.Data],
				pendingNoOfItemsReceived: Number(action.payload.Data.length),
				pendingCount: Number(action.payload.Data.length),
				pendingTotalCount: Number(action.payload.TotalCount),
				pendingPage: 1,
				error: null,
			};
		default:
			return state;
	}
};

export const getConsumersList = (data: IGetConsumersListModel) => {
	return async (dispatch) => {
		dispatch({ type: types.CONSUMERS_GET_LIST_REQUEST });
		try {
			const response = await getConsumersListApi(data);
			const payload = response.data.Data;
			if (data.status === Constants.BToC_CONSUMERS_STATUS_PENDING) {
				dispatch({
					type: types.CONSUMERS_GET_PENDING_LIST_SUCCESS,
					payload,
					page: data.page,
					totalCount: response.data.TotalCount,
				});
			} else {
				dispatch({
					type: types.CONSUMERS_GET_APPROVAL_LIST_SUCCESS,
					payload,
					page: data.page,
					totalCount: response.data.TotalCount,
				});
			}
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.CONSUMERS_GET_LIST_FAILURE));
		}
	};
};

export const searchConsumersList = (data: ISearchConsumersListModel) => {
	return async (dispatch) => {
		dispatch({ type: types.CONSUMERS_SEARCH_LIST_REQUEST });
		try {
			const response = await searchConsumersListApi(data);
			const payload = response.data.Data;

			dispatch({
				type: types.CONSUMERS_GET_APPROVAL_LIST_SUCCESS,
				payload,
				page: data.page,
				totalCount: response.data.TotalCount,
			});
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.CONSUMERS_SEARCH_LIST_FAILURE));
		}
	};
};

export const updateConsumer = (data: IUpdateConsumerModel) => {
	return async (dispatch) => {
		dispatch({ type: types.CONSUMER_UPDATE_NEW_REQUEST });
		try {
			await updateConsumerApi(data);

			if (data.status === Constants.BToC_CONSUMERS_STATUS_ACTION_APPROVE) {
				dispatch(showMsgFromJson(`store.consumers.successMessages.consumerApproved`, Constants.SUCCESS));
			} else {
				dispatch(showMsgFromJson(`store.consumers.successMessages.consumerRejected`, Constants.SUCCESS));
			}

			const pendingConsumersResponse = await getConsumersListApi({
				page: 1,
				status: Constants.BToC_CONSUMERS_STATUS_PENDING,
				Sorting: Constants.NAME_ASC,
			});
			const payload = pendingConsumersResponse.data;

			dispatch({ type: types.CONSUMER_UPDATE_NEW_SUCCESS, payload });
		} catch (error) {
			if (data.status === Constants.BToC_CONSUMERS_STATUS_ACTION_APPROVE) {
				dispatch(showMsgFromJson(`store.consumers.errorMessages.updateConsumer`, Constants.ERROR));
			} else {
				dispatch(showMsgFromJson(`store.consumers.errorMessages.rejectConsumer`, Constants.ERROR));
			}
			dispatch(promiseCatchBlock(error, types.CONSUMER_UPDATE_NEW_FAILURE));
		}
	};
};

const promiseCatchBlock = (error: any, type: string) => {
	return (dispatch) => {
		const { message } = getErrorObject(error);
		dispatch({
			type: type,
			payload: { error: message },
		});
	};
};
